<template>
  <v-app>
    <Lightbox :file="file" />
  </v-app>
</template>

<script>
import Lightbox from './components/messages/lightbox'

export default {
  components: { Lightbox },
  computed: {
    isPreview() {
      return this.$store.state.isPreview
    },
    file() {
      return this.$store.state.file
    }
  },
}
</script>

<style lang="scss">
  .v-application--wrap {
    min-height: 0 !important;
  }
</style>
